var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts-contain"},[_c('div',{staticClass:"o-echarts",attrs:{"id":_vm.id}}),(_vm.$attrs.showYear)?_c('div',{staticClass:"currentYear"},[_vm._v(_vm._s(new Date().getFullYear())+"年")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }